
export const phoneHyphen = (phoneNumber: string) => {
    if (!phoneNumber) return phoneNumber;
    phoneNumber = phoneNumber.replace(/[^0-9]/g, "");
  
    let res = "";
    if (phoneNumber.length < 3) {
      res = phoneNumber;
    } else {
      if (phoneNumber.substr(0, 2) == "02") {
        if (phoneNumber.length <= 5) {
          //02-123-5678
          res = phoneNumber.substr(0, 2) + "-" + phoneNumber.substr(2, 3);
        } else if (phoneNumber.length > 5 && phoneNumber.length <= 9) {
          //02-123-5678
          res =
            phoneNumber.substr(0, 2) +
            "-" +
            phoneNumber.substr(2, 3) +
            "-" +
            phoneNumber.substr(5);
        } else if (phoneNumber.length > 9) {
          //02-1234-5678
          res =
            phoneNumber.substr(0, 2) +
            "-" +
            phoneNumber.substr(2, 4) +
            "-" +
            phoneNumber.substr(6);
        }
      } else {
        if (phoneNumber.length < 8) {
          res = phoneNumber;
        } else if (phoneNumber.length == 8) {
          res = phoneNumber.substr(0, 4) + "-" + phoneNumber.substr(4);
        } else if (phoneNumber.length == 9) {
          res =
            phoneNumber.substr(0, 3) +
            "-" +
            phoneNumber.substr(3, 3) +
            "-" +
            phoneNumber.substr(6);
        } else if (phoneNumber.length == 10) {
          res =
            phoneNumber.substr(0, 3) +
            "-" +
            phoneNumber.substr(3, 3) +
            "-" +
            phoneNumber.substr(6);
        } else if (phoneNumber.length > 10) {
          //010-1234-5678
          res =
            phoneNumber.substr(0, 3) +
            "-" +
            phoneNumber.substr(3, 4) +
            "-" +
            phoneNumber.substr(7);
        }
      }
    }
    return res;
  };
  
  export const emailValidate = (id: string) => {
    const errors = { id, valid: true };
  
    if (!id) {
      errors.id = "이메일이 입력되지 않앗습니다.";
      errors.valid = false;
    } else if (id.search(/\s/) != -1) {
      errors.id = "입력된 이메일에 공백이 존재합니다.";
      errors.valid = false;
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(id)) {
      errors.id = "입력된 이메일이 유효하지 않습니다.";
      errors.valid = false;
    }
    return errors;
  };
  
  export const passwordValidate = (pw: string, 
    setModalOpen:any,
    setModalMsg:any) => {

    // var regExp = "^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$;
    // return regExp.test(pw);
  
    var num = pw.search(/[0-9]/g);
    var eng = pw.search(/[a-z]/gi);
    // var spe = pw.search(/[`~!@@#$%^&*|₩₩₩'₩";:₩/?]/gi);
  
    if (pw.length < 6 || pw.length > 20) {
      setModalOpen(true);
      setModalMsg("비밀번호를 6자리 ~ 20자리 이내로 입력해주세요.");
      // alert("6자리 ~ 20자리 이내로 입력해주세요.");
      return false;
    } else if (pw.search(/\s/) != -1) {
      setModalOpen(true);
      setModalMsg("비밀번호는 공백 없이 입력해주세요.");
      // alert("비밀번호는 공백 없이 입력해주세요.");
      return false;
    } else if (num < 0 || eng < 0) {
      setModalOpen(true);
      setModalMsg("영문,숫자를 혼합하여 비밀번호를 입력해주세요.");
      // alert("영문,숫자를 혼합하여 입력해주세요.");
      return false;
    } else {
      return true;
    }
  };
  